module.exports = __webpack_public_path__ + "static/media/motherjones_politics_2016_06_cca-private-prisons-corrections-corporation-inmates-investigation-bauer_plot.3d066518.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/motherjones_politics_2016_06_cca-private-prisons-corrections-corporation-inmates-investigation-bauer_plot.png
// module id = 398
// module chunks = 0